<template>
    <v-container grid-list-xl>
        <v-col cols=7 class="mx-auto" v-if="isTeacher">
            <div class="display-3 font-weight-thin mt-8">{{ getName }}</div>

            <v-form ref="form" class="mt-8">
                <v-select v-if="getTeachings.length > 1" v-model="subject" :items="subjects" :placeholder="$i18n.t('selectSubject')" :rules ="subjectRules" dense outlined class="mt-3"/>
            </v-form>

            <v-btn block large @click="viewTests" color="grey lighten-3" exact class="mt-6">
                <v-icon left>library_books</v-icon>
                {{ $t('tests') }} 
            </v-btn>

            <v-btn block large @click="viewQuestions" color="grey lighten-3" exact class="mt-6">
                <v-icon left>question_answer</v-icon>
                {{ $t('questions') }} 
            </v-btn>

            <v-divider class="mt-6"/>

            <v-btn block large @click="$router.push('/userConfig')" color="grey lighten-3" exact class="mt-6">
                <v-icon left>settings</v-icon>
                {{ $t('userConfig') }}
            </v-btn>
        </v-col>
        <v-col cols=7 class="mx-auto" v-else>
            <div class="display-3 font-weight-thin mt-8">{{ getName }}</div>
            <v-btn block large @click="viewSubjects" color="grey lighten-3" exact class="mt-6">
                <v-icon left>book</v-icon>
                {{ $t('subjects') }} 
            </v-btn>

            <v-btn block large @click="viewUsers" color="grey lighten-3" exact class="mt-6">
                <v-icon left>people</v-icon>
                {{ $t('users') }} 
            </v-btn>
        </v-col>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            subjectRules: [
                v => !!v || this.$i18n.t('noSubject')
            ]
        }
    },

    methods: {
        logOut() {
            this.$store.dispatch('logout')
            .then(() => {
                this.$router.push('/login')
            });
        },
        viewTests() {
            if (this.$refs.form.validate())
                this.$router.push('/tests')
        },
        viewQuestions() {
            if (this.$refs.form.validate()) {
                this.$store.commit('setActiveTopic', undefined)
                this.$router.push('/questions')
            }
        },
        viewUsers() {
            this.$router.push('/users')
        },
        viewSubjects() {
            this.$router.push('/subjects')
        },
    },

    created() {
        this.$store.dispatch('getTeachings', this.getUserId)
        .then(() => {
            if (this.getTeachings.length == 1)
                this.subject = this.getTeachings[0].subject.name
        })
    },

    computed: {
        ...mapGetters([
            'isAuthenticated',
            'getUserId',
            'getName',
            'getTeachings',
            'isAdmin',
            'isTeacher',
        ]),
        subject: {
            get() { return localStorage.getItem('subject') },
            set(value) {
                this.$store.commit('setCurrentSubject', value)
                this.$store.commit('setCurrentSubjectId', this.getTeachings.find(teaching => teaching.subject.name == value).subject.id)
            },
        },
        subjects() {
            return this.getTeachings.map(teaching => teaching.subject.name)
        },
    }
}
</script>
